/**
 * 盘口上下架：listStatus 0 待上架 / 1 已上架 / 2 下架。
 * 无 listStatus 字段的数据源（如第三方）默认可展示。
 */
export function isListedMarket(market) {
  if (!market || typeof market !== 'object') return false;
  const raw = market.listStatus;
  if (raw == null || raw === '') return true;
  return Number(raw) === 1;
}

/** @param {unknown} markets */
export function filterListedMarkets(markets) {
  if (!Array.isArray(markets)) return [];
  return markets.filter(isListedMarket);
}

/** @param {unknown} markets */
export function getFirstListedMarket(markets) {
  return filterListedMarkets(markets)[0] ?? null;
}

/**
 * 详情页主盘口：优先已上架；短周期结算后 listStatus=UNLISTED，
 * 必须回退到已关闭/已结算盘，否则 firstMarket 为空、结果解析失败。
 */
export function getDetailPrimaryMarket(markets) {
  const listed = getFirstListedMarket(markets);
  if (listed) return listed;
  if (!Array.isArray(markets) || markets.length === 0) return null;
  const closedOrResolved = markets.find((m) => {
    if (!m || typeof m !== 'object') return false;
    const status = String(m.marketStatus ?? '').trim().toLowerCase();
    if (status === 'resolved' || status === 'awaitingresult') return true;
    return Number(m.closed) === 1 || m.closed === true;
  });
  return closedOrResolved || markets[0] || null;
}

/** collection / 详情 payload 是否含可展示的上架盘口 */
export function hasListedCollectionMarkets(row) {
  return filterListedMarkets(row?.markets).length > 0;
}
